import './style';
import Header from 'components/Header';
import Intro from 'components/Intro';
import IntroViz from 'components/IntroViz';
import PhysicalChanges from 'components/PhysicalChanges';
import VerbalChanges from 'components/VerbalChanges';
import PersonalityChanges from 'components/PersonalityChanges';
import RelatedContent from 'components/RelatedContent';
import Conclusion from 'components/Conclusion';
import Footer from 'components/Footer';
import copy from './copy.txt';

if (module.hot) {
	require('preact/debug');
}

export default () => (
	<div>
		<svg
			viewBox="0 0 100 100"
			style={{
				position: 'absolute',
				top: -9999,
				left: -9999
			}}
		>
			<defs>
				<clipPath id={`circle`}>
					<circle cx="50" cy="50" r="50" />
				</clipPath>
			</defs>
		</svg>

		<Header tweetText={copy.tweetText} />
		<Intro />
		<IntroViz />
		<PhysicalChanges />

		<VerbalChanges
			title={copy.verbalChangesTitle}
			standFirstPer={copy.verbalChangesStandfirstPer}
			standFirst={copy.verbalChangesStandfirst}
			verbalChangesViz4={copy.verbalChangesViz4}
			verbalChangesViz2Title={copy.verbalChangesViz2Title}
			verbalChangesViz2={copy.verbalChangesViz2}
			verbalChangesViz2Emoji={copy.verbalChangesViz2Emoji}
			text1={copy.verbalChangesText1}
			text2={copy.verbalChangesText2}
			text3={copy.verbalChangesText3}
			text4={copy.verbalChangesText4}
			text5={copy.verbalChangesText5}
			viz1={copy.verbalChangesViz1}
			viz3={copy.verbalChangesViz3}
			viz3Title={copy.verbalChangesViz3Title}
			viz4Title={copy.verbalChangesViz4Title}
		/>

		<PersonalityChanges copy={copy} />

		<Conclusion copy={copy} />

		<RelatedContent
			title={copy.relatedContentTitle}
			related={copy.relatedContent}
		/>
		<Footer sourceTitle={copy.sourceTitle} sourceText={copy.sourceText} />
	</div>
);



// WEBPACK FOOTER //
// ./index.js